export const InvalidDiscountImageResources = {
    invalidDiscountText: "Oferta Archiwalna",
    goActiveOffers: "Przejdź do aktualnych ofert",
};
